/**
 * @module mapbs.components.applications.applications
 */

import angular from 'angular';
import mapbsApplicationLink from 'mapbs/components/applications/applicationlink/applicationlink';

const moduleApplication = angular.module('mapbsApplicationsModule', [
    mapbsApplicationLink.name,
]);

moduleApplication.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put('mapbs/applications', require('./applications.html'));
    }
);

/** @type {!angular.Component} */
const ApplicationsComponent = {
    controller: 'mapbsApplicationsController as ctrl',
    templateUrl: 'mapbs/applications',
    bindings: {
        'applicationList': '<mapbsApplicationsLinks',
        'mobile': '<?mapbsApplicationsMobile',
    },
};

moduleApplication.component('mapbsApplications', ApplicationsComponent);

class ApplicationsController {
    /**
   * @constructor
   * @param {angular.Scope} $scope
   * @private
   * @ngInject
   */
    constructor($scope) {
    /**
     * @type {Array<mapbs.components.applications.applicationlink.applicationLinkData>}
     */
        this.applicationList = [];

        /**
     * @type {boolean}
     */
        this.mobile = false;

        /**
     * @type {string}
     */
        this.activeLink = '';

        $scope.$on('open_link', (event, name) => (this.activeLink = name));
    }
}

moduleApplication.controller('mapbsApplicationsController', ApplicationsController);

export default moduleApplication;
